/**
 * Created by tiedong on 2017/6/7.
 */
import * as types from '../constants/ActionTypes'




let clearChatMessage = () =>{
    let chatMessageHistory = {message:'',seRequestId:''}

    return {
        type: types.GET_CHATMESSAGE_HISTORY_FINISH,
        payload: {
            chatMessageHistory
        }
    }
}


export default {
    clearChatMessage
}
